import React, { useContext, useEffect } from "react";
import { connect } from "react-redux";
import { Check } from "@material-ui/icons";
import { Circle, SuccessContainer, SuccessInfo, SuccessTitle } from "./SignInOutForm.style";
import { AuthContext } from "../../contexts/auth/auth.context";
import { resetAuthState } from "../../store/actions/authAction";
import t from "../../i18n/translate";

export const Success = (props) => {
  const isExpress = localStorage.getItem("expressMode");
  const { authDispatch } = useContext(AuthContext);
  
  useEffect(() => {
    let isCurrent = true;
    let timeout;

    if (isCurrent) {
      timeout = setTimeout(() => {
        props.resetAuthState();
        authDispatch({ type: "SIGNIN" });
      }, 3000);
    }

    return () => {
      isCurrent = false;
      clearTimeout(timeout);
    };
  }, []);

	return (
		<SuccessContainer>
			<Circle className={`${isExpress ? "express" : ""}`}>
				<Check className="check" />
			</Circle>
      <SuccessTitle>{t("popup_success_title")}!</SuccessTitle>
			<SuccessInfo>{props.resetmessage.includes("reset") ? t("change_password_popup_success_reset_password_description") :  props.responsemsg.includes("registered") ? t("sign_up_popup_success_message") : "" }</SuccessInfo>
		</SuccessContainer>
	);
};

const mapStateToProps = (state) => ({
	loginresponsemsg: state.authReducer.loginresponsemsg,
	resetmessage: state.authReducer.resetmessage,
	responsemsg: state.authReducer.responsemsg,
});

const mapDispatchToProps = (dispatch) => {
  return {
    resetAuthState: () => resetAuthState(dispatch),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Success);
